import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *我的团队账号搭建信息
 * @param params
 * 
*/

export const myTeamInfo = params => Http.get(`${baseUrl}/sz/team/dj/my`, { params })

/**
 *提交团队账号搭建信息
 * @param params
 * 
*/

export const submit = params => Http.post(`${baseUrl}/sz/team/dj/submit`,  params )

/**
 *搭建成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/dj`, { params })